export default __webpack_public_path__ + "static/media/Quit Smoking.f35f9e00.jpg";